import { userConstants } from '../_constants'

const INITIAL_STATE = {
  allUsers: [],
  allDrivers: [],
  allRUsers: [],
}

const userReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case userConstants.GET_ALL_DRIVERS:
      return Object.assign({}, state, {
        allDrivers: action.payload.users,
      })
    case userConstants.GET_ALL_USERS:
      return Object.assign({}, state, {
        allUsers: action.payload.users,
      })
    case userConstants.GET_ALL_RUSERS:
      return Object.assign({}, state, {
        allRUsers: action.payload.users,
      })
    default:
      return state
  }
}

export default userReducer
